import React, {useEffect, useState} from "react";
import "../CSS/Services4.css";
import axios from "axios";

const Services4=({title})=>{

    
    const [services, setServices] = useState([]);
    const [currentSubtitleIndex, setCurrentSubtitleIndex] = useState(0);

    useEffect(() => {
      const fetchFilteredServices = async () => {
        try {
          const response = await axios.get(`https://us-central1-janushreebeautyparlour.cloudfunctions.net/api/getServicesSection4`, {
            params: { title },
          });
          setServices(response.data);
          console.log("responseofservice3:", response.data);
        } catch (error) {
          console.error("Error fetching services:", error);
        }
      };
  
      fetchFilteredServices();
    }, [title]);

    useEffect(() => {
      const interval = setInterval(() => {
        setCurrentSubtitleIndex((prevIndex) =>
          services[0]?.subtitles4
            ? (prevIndex + 1) % services[0].subtitles4.length
            : 0
        );
      }, 8000); // Change every 4 seconds
  
      return () => clearInterval(interval);
    }, [services]);

    return(
        <div className="hero containerservice4">
            <div className="cube4"></div>
            <div className="cube4"></div>
            <div className="cube4"></div>
            <div className="cube4"></div>
            <div className="cube4"></div>
            <div className="cube4"></div>
            {services.map((service, index) => (
            <div  key={index} className="container">
                <div className="row justify-content-center text-center">
                    <div className="col-md-10 col-lg-8">
                        <div className="header-section">
       
                            <>
                                <h2 className="title blackthemegradient">{service.title}</h2>
                                <p className="description text-white">
                                {service.description}
                                </p>
                                </>
                        </div>
                    </div>
                    </div>
                    <div className="row">
                      <div className="col">
                      {service.subtitles4.length > 0 && (
                    <div className="tips-section4">
                    <div className="tips-section__content4 glassmorphism4">
                    <h1 className=" mb-4 text-center blackthemegradient">{service.subtitles4[currentSubtitleIndex]?.subtitle}</h1>
                        <p className="tips-description4 text-white">
                        {
                        service.subtitles4[currentSubtitleIndex]
                          ?.subdescription
                      }
                        </p>
                    </div>
                    <div className="tips-section__image4">
                    <figure className="swing">
                      <img  src={
                        service.subtitles4[currentSubtitleIndex]?.subimage || ""
                      }
                      alt={
                        service.subtitles4[currentSubtitleIndex]?.subtitle || ""
                      }
                      className="subtitle-image"
                    />
              
              </figure>
                    </div>
                    </div>
                  )}
          </div>
        </div>
      </div>
    ))}
    </div>
    );
}

export default Services4;